export default {"src":"/_next/static/media/live-support.2e408e87.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};